import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-4">
          <div className="max-w-md text-center">
            <div className="w-20 h-20 bg-[#FF007F]/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[#FF007F]">
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <h1 className="font-heading text-3xl font-black mb-3">Ops! Algo deu errado</h1>
            <p className="text-zinc-400 mb-6">
              Encontramos um erro inesperado. Você pode voltar para a página inicial ou tentar novamente.
            </p>
            {this.state.error && (
              <details className="text-left bg-black/40 border border-white/10 rounded-xl p-3 mb-6 text-xs text-zinc-500">
                <summary className="cursor-pointer mb-2">Detalhes técnicos</summary>
                <code className="break-all">{String(this.state.error?.message || this.state.error)}</code>
              </details>
            )}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={this.handleReset}
                className="px-6 py-3 bg-[#FF007F] hover:bg-[#FF3399] rounded-full font-bold transition-all"
                data-testid="error-back-home"
              >
                Voltar ao Início
              </button>
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full font-bold transition-all"
                data-testid="error-reload"
              >
                Recarregar
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
